import { ITableHeaderItem } from '@components/Table/Table';

export const useTableHeader = (action: (key: string) => () => void) => {
  const HEADER_LIST: ITableHeaderItem[] = [
    {
      name: 'Last edit',
      action: {
        action: action('LastEdit'),
        position: 'end',
      },
    },
    {
      name: 'Selection name',
      action: {
        action: action('Name'),
        position: 'end',
      },
    },
    { name: 'Generated files' },
    { name: 'Expiration date' },
  ];

  return {
    HEADER_LIST,
  };
};
